<template>
    <div>
        <b-modal
      id="modal-xl"
      ref="my-modal"
      no-close-on-backdrop
      ok-title="Close"
      @hidden="close()"
      scrollable
      centered
      modal-header
      button-size="sm"
      size="xl"
      title="Invoice Review"
    >
     <embed :src="iframe_src" width="100%" height="600px" type="application/pdf">
      <template #modal-footer="{ ok , closeModal  }">
        <span class="mx-2" style="border-left:0px solid #aaa;height:50%;">|</span>

      <!-- Button with custom close trigger value -->
      <b-button size="sm" variant="outline-secondary" @click="close()">
        Close
      </b-button>
    </template>
      </b-modal>
      <b-row>
        <b-col cols="3">
          <b-row>
        <b-col
          cols="12"
          md="12"
          class="align-items-center justify-content-start mb-1 mb-md-0"
        >
        <flat-pickr
            v-model="rangeDate"
            class="form-control mb-1 mr-1"
            :config="{ mode: 'range'}"
          />
                          <v-select
                            class="mb-1"
                            v-model="center_id"
                            multiple
                            label="label"
                            :clearable="true"
                            :reduce="group => group.value"
                            :options="centerOptions"
                          />
                          <b-button block size="sm" variant="outline-warning" class="mt-1" @click="select_center_all()">全部</b-button>
                          <hr />
        </b-col>
        
        <b-col cols="12" md="12">
        <v-select :reduce="workshop => workshop.id" multiple :options="workshopOptions" v-model="selected_workshop"></v-select>
        <b-button block size="sm" variant="outline-warning" class="mt-1" @click="select_workshop_all()">全部 ( 工作坊 )</b-button>
        <hr />
      </b-col>
      <b-col cols="12" md="12" class="mb-2">
        <v-select :reduce="product => product.id" multiple :options="productOptions" v-model="selected_product"></v-select>
        <b-button block size="sm" variant="outline-warning" class="mt-1" @click="select_product_all()">全部 （ 產品 )</b-button>
      </b-col>
      <b-col cols="12" md="12" class="mb-2">
        <b-button block size="sm" variant="outline-info" class="mt-1" @click="select_trial()">試堂</b-button>
      </b-col>
        <b-col
          cols="12"
          md="12"
        >
            <b-button
              variant="primary"
              class="mb-1"
              @click="exportToExcel()"
            >
              <span class="text-nowrap">Export</span>
            </b-button>

        </b-col>
      </b-row>
          </b-col>
        <b-col cols="9">
      
      <!-- table -->
      <b-table
        ref="selectableTable"
        selectable
        :select-mode="selectMode"
        :items="items"
        :fields="fields"
        responsive
        striped
        class="mb-0"
        @row-selected="onRowSelected"
      >
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
  
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item :to="{ name: 'apps-Member-view', params: { id: data.item.id } }">
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">Details</span>
            </b-dropdown-item>
  
            <b-dropdown-item :to="{ name: 'apps-Member-edit', params: { id: data.item.id } }">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>
  
            <b-dropdown-item>
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
        <template #cell(status_number)="data">
          <b-badge :variant="status[1][data.value]">
            {{ status[0][data.value] }}
          </b-badge>
        </template>
        <template #cell(student_name)="data">
         
            {{ data.item.zh_name }} {{ data.item.en_name }}

        </template>
        <template #cell(amount)="data">
          <span v-if="data.item.status == 'VOID'" style="color:red;"><b> -{{data.item.amount}}</b></span>
          <span v-if="data.item.status == 'ACTIVE'">{{data.item.amount}}</span>
        </template>
      </b-table>
    </b-col>
  </b-row>
    </div>
  </template>
  
  <script>
  import BCardCode from '@core/components/b-card-code/BCardCode.vue'
  
  import vSelect from 'vue-select'
  import Ripple from 'vue-ripple-directive'
  import flatPickr from 'vue-flatpickr-component'
  import moment from 'moment'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import {
    BTable, BAvatar, BCardBody, BBadge,  BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BInputGroupPrepend,BModal, VBModal} from 'bootstrap-vue'
  export default {
    components: {
      moment,
      flatPickr,
      BTable,
      ToastificationContent,
      BModal, VBModal,
      BAvatar,
      BBadge,
      BRow,
      BCol,
      BFormGroup,
      BFormSelect,
      BPagination,
      BInputGroup,
      BFormInput,
      BInputGroupAppend,
      BInputGroupPrepend,
      BButton,
      BPagination,
      BCardCode,
      BTable,
      BButton,
      BFormGroup,
      BAvatar,
      BCardBody,
      BBadge,
      vSelect,
    },
    directives: {
      Ripple,
    },
    data() {
      return {
        iframe_src : '//rb.cloudedu.pro/invoice.php',
        rangeDate: null,
        searchString: null,
        productOption : null,
        center_filter:null,
        productOptions:[],
        type:'all',
        selected_product:null,
        selected_workshop:null,
        test_string : null,
        center_id : this.$store.getters['center/currentCenterId'] ,
        headerTitle: [],
        headerVal: [],
        centerOptions: [],
        workshopOptions: [],
        isAddNewMemberSidebarActive: false,
        searchString: null,
        perPage: 10,
        startRow: 1,
        trial:false,
        endRow: 10,
        totalAmount: 0,
        pageOptions: [10, 15, 20],
        totalRows: 1,
        currentPage: 1,
        fields: [
          { key: 'code', label: 'Transaction ID' }, 
          { key: 'item_name',label: 'Item Name'},
          { key: 'price',label: 'Amount'},
          { key: 'student_code', label: 'Student Code' },
          { key: 'zh_name', label: 'Chinese Name' },
          { key: 'en_name', label: 'English Name' },
          { key: 'student_code', label: 'Student Code' }, 
          { key: 'created_at', label: 'Created At' },
          { key: 'display_name', label: 'Staff' }
        ],
        /* eslint-disable global-require */
        items: [],
        /* eslint-disable global-require */
        status: [{
          1: 'Active', 2: 'Disabled', 3: 'Rejected', 4: 'Resigned', 5: 'Applied',
        },
        {
          1: 'light-success', 2: 'light-danger', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
        }],
        selectMode: 'single',
        selected: [],
      }
    },
    watch: {
      
      rangeDate : {
        handler(newValue, oldValue) {
          this.get_data()
        },
      },
      center_id : {
        handler(newValue, oldValue) {
          this.get_data()
        },
      },
      selected_product : {
        handler(newValue, oldValue) {
          if (newValue != null) {
            this.selected_workshop = null
            this.get_data()
          }
        },
      },
      selected_workshop : {
        handler(newValue, oldValue) {
          if (newValue != null) {
            this.selected_product = null
            this.get_data()
          }
        },
      },
      currentPage: {
        handler(newValue, oldValue) {
          this.get_data()
        },
      },
      searchString: {
        handler(newValue, oldValue) {
          // console.log("search")
          this.searchString = newValue.toUpperCase()
          this.handleSearch()
        },
      },
      perPage: {
        handler(newValue, oldValue) {
          if (newValue < 9) {
            this.perPage = 10
          }
          // console.log("search")
          this.handleSearch()
        },
      },
    },
    created() {
      this.copy_excel_field()
      this.get_center_data()
      this.get_data()
      this.get_product_data()
      this.get_workshop_data()
    },
    methods: {
      copy_excel_field() {
        this.fields.forEach((item , index) => {
          console.log(item.key)
          this.headerTitle.push(item.label)
          this.headerVal.push(item.key)
        })
      },
    onRowSelected(items) {
        this.selected = items[0]
        this.iframe_src = '//rb.cloudedu.pro/pdf/INVOICE_'+items[0].code+'.pdf?rand='+this.makeid(10)
        this.transaction_id = items[0].transaction_id
        this.$refs['my-modal'].show()
    },
      select_center_all(){
        this.center_id = []
        this.centerOptions.forEach((center, index) => {
          this.center_id.push(center.id)
        })
      },
      select_workshop_all(){
        this.selected_workshop = []
        this.workshopOptions.forEach((workshop, index) => {
          this.selected_workshop.push(workshop.id)
        })
      },
      select_product_all(){
        this.selected_product = []
        this.productOptions.forEach((product, index) => {
          this.selected_product.push(product.id)
        })
      },
      select_trial() {
        this.trial = true
        this.get_data()
      },
      exportToExcel() {
        import('@/@core/Export2Excel').then(excel => {
          const list = this.items
          const data = this.formatJson(this.headerVal, list)
          excel.export_json_to_excel({
            header: this.headerTitle,
            data,
            filename: 'product_report',
            autoWidth: true,
            bookType: 'xlsx'
          })
          //this.clearFields()
        })
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v =>
          filterVal.map(j => {
            console.log(j)
            // Add col name which needs to be translated
            // if (j === 'timestamp') {
            //   return parseTime(v[j])
            // } else {
            //   return v[j]
            // }
  
            return v[j]
          })
        )
      },
      get_data(searchString = null) {
        var splitted = []
        if (this.rangeDate === null) {
          splitted[0] = moment().subtract(7, 'days').format('YYYY-MM-DD')
          splitted[1] = moment().format("YYYY-MM-DD")
          this.rangeDate = moment().subtract(7, 'days').format('YYYY-MM-DD') + " to " + moment().format("YYYY-MM-DD")
        } else {
          splitted = this.rangeDate.split(" to ");
        }
        this.$http.get(process.env.VUE_APP_API_BASE+`/report/product/`+ this.center_id + `/?workshop_id=`+this.selected_workshop+`&product_id=`+this.selected_product+`&trial=`+ this.trial +`&from=`+splitted[0]+`&to=`+splitted[1])
          .then(res => {
            if (res.data.result === true) {
            this.items = res.data.transactions
            this.totalRows = this.items.length
            this.totalAmount = 0
              console.log( res.data )
              this.items.forEach((item, i) => {
                if (item.status == 'ACTIVE') {
                  this.totalAmount += parseInt(item.amount)
                }
              });
            } else {
              this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
            }
            this.trial = false
          })
      },
      
      get_product_data() {
        this.$http.get(process.env.VUE_APP_API_BASE+'/products/?status=ALL')
          .then(res => {
            this.productOptions = res.data.products
          })
      },
      get_workshop_data() {
        this.$http.get(process.env.VUE_APP_API_BASE+'/short_courses/?type=all')
          .then(res => {
            this.workshopOptions = res.data.short_courses
          })
      },
      
      handleChangePage() {
  
      //  this.get_data()
      },
      onRowSelected(items) {
        this.selected = items[0]
        this.iframe_src = '//rb.cloudedu.pro/pdf/INVOICE_'+items[0].code+'.pdf?rand='+this.makeid(10)
        this.transaction_id = items[0].transaction_id
        this.$refs['my-modal'].show()
      },
       makeid(length) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
          counter += 1;
        }
        return result;
      },
      get_center_data() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/centers/')
        .then(res => {
          this.centerOptions = res.data.centers
        })
    },
      close() {
        this.iframe_src = '//www.cloudfit.pro/invoice.php'
        this.$refs['my-modal'].hide()
        this.clearSelected()
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows()
      },
      clearSelected() {
        this.$refs.selectableTable.clearSelected()
      },
      selectThirdRow() {
        // Rows are indexed from 0, so the third row is index 2
        this.$refs.selectableTable.selectRow(2)
      },
      unselectThirdRow() {
        // Rows are indexed from 0, so the third row is index 2
        this.$refs.selectableTable.unselectRow(2)
      },
  
      handleSearch() {
        // let _print = `The user searched for: ${searching}\n`
        // this.$refs.pre.appendChild(document.createTextNode(_print))
      // this.searchString = searching
      // this.currentx = 1
      // this.get_data()
        this.searchTimeOut()
      },
      searchTimeOut() {
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
        this.timer = setTimeout(() => {
          // your code
          this.currentPage = 1
          this.get_data(this.searchString)
        }, 500)
      },
    },
  }
  </script>
  <style lang="scss">
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
  </style>
  <style lang="scss">
  .b-table-selectable{
    .feather{
      font-size: 1.3rem;
    }
  }
  
  </style>
  